export default "__VITE_ASSET__CQyPC5t$__"